import { Box, Stack } from '@chakra-ui/react';
import { PiIdentificationBadgeFill } from 'react-icons/pi';
import InputMobile from '../../../../../../components/Input/Mobile';
import InputAttachmentFile from '../../../../Resources/mobile/create/attachmentFile';
import TitleSectionMobilePage from '../../../../../../components/Mobile/titleSection';

const NisFormMobile: React.FC<{ nisRequired: boolean; documentRequired: boolean }> = ({
  nisRequired,
  documentRequired,
}) => {
  const accent = '#222';

  return (
    <Stack spacing={5}>
      <InputMobile
        isRequired={nisRequired}
        name="nis"
        placeholderLabel="Informe seu NIS"
        iconLeft={<PiIdentificationBadgeFill size={15} color={accent} />}
        onlyNumber
      />
      <Box>
        <TitleSectionMobilePage
          border="none"
          mb={0}
          fontSize="13px"
          fontWeight="normal"
          isRequired={documentRequired}
        >
          Envio de documento:
        </TitleSectionMobilePage>
        <InputAttachmentFile inputName="attachmentExemption" accept=".pdf,.jpg,.jpeg,.png" />
      </Box>
    </Stack>
  );
};

export default NisFormMobile;
